import React, { useEffect, useState } from 'react';
import { Alert, Box, Button, Card, CardContent, Checkbox, Grid, MenuItem, TextField, Typography, FormControlLabel } from '@mui/material';
import axios from 'axios';
import { token, apiUrl } from '../../../../../api';
import api from '../../../../services/api';

const API_BASE = process.env.REACT_APP_BACKEND_SERVER || 'http://127.0.0.1:8000';

const SwitchboardNew = ({ onClose }) => {
    //? --------------------------- DEFININDO AS VARIAVEIS INICIAIS ---------------------------
    const [status, setStatus] = useState({ type: '', message: '' });
    const [app, setApp] = useState(null);
    const [desabilitarPodeCriarSb, setDesabilitarPodeCriarSb] = useState(true);
    const [listaApps, setListaApps] = useState([]);
    const [listaIntegrations, setListaIntegrations] = useState([]);
    const [appFoiSelecionado, setAppFoiSelecionado] = useState(false);
    const [switchboards, setSwitchboards] = useState([]);
    const [pediuCriarSw, setPediuCriarSw] = useState(false);
    const [wizardData, setWizardData] = React.useState({
        app: {
            name: '',
            id: ''
        },
        switchboard: {
            name: '',
            id: ''
        }
    });

    //? --------------------------- LISTANDO APPS ---------------------------
    useEffect(() => {
        loadApps();
    }, []);

    useEffect(() => {
        if (!wizardData.app.id) return;
        loadSwitchboards();
    }, [wizardData.app.id]);

    const loadApps = async () => {
        console.log('entrou em loadApps');
        try {
            const res = await api.get(`v1/apps/`);
            // const res = await axios.get(`${API_BASE}/api/v1/apps/`, {
            //     headers: {
            //         Authorization: token,
            //         'Content-Type': 'application/json'
            //     }
            // });
            if (res.data) {
                setListaApps(res.data.apps);
                console.log(`Apps carregados: ${JSON.stringify(res.data.apps)}`);
                console.log('fim da loadApps');
            } else {
                setStatus({ type: 'error', message: 'Erro ao carregar Apps' });
            }
        } catch (err) {
            setStatus({ type: 'error', message: 'Erro ao carregar Apps' });
            console.error('Erro ao carregar Apps', err);
        }
    };

    useEffect(() => {
        if (listaApps.length > 0 && !wizardData.app.id) {
            setWizardData((prev) => ({
                ...prev,
                app: {
                    ...prev.app,
                    id: listaApps[0].id
                }
            }));
            setAppFoiSelecionado(true);
        }
    });

    //? ------------------------------ LOAD SWITCHBOARD ---------------------------
    const loadSwitchboards = async () => {
        console.log('entrou em loadSwitchboard');
        try {
            const res = await api.get(`v1/apps/${wizardData.app.id}/switchboards/`);
            if (res.data) {
                setSwitchboards(res.data.switchboards);
                if (res.data.switchboards.length === 0) {
                    setDesabilitarPodeCriarSb(false);
                }
            } else {
                setStatus({ type: 'error', message: 'Não existem Switchboards ativos.' });
            }
        } catch (err) {
            setStatus({ type: 'error', message: 'Erro ao carregar Switchboards' });
        }
    };

    //? --------------------------- CRIANDO O SWITCHBOARD --------------------------
    const createSwitchboard = async () => {
        console.log('Criando switchboard:', wizardData.switchboard);

        try {
            const payload = {
                name: wizardData.switchboard.name,
                enabled: 'True'
                // ,defaultSwitchboardIntegrationId: ''
            };

            const res = await api.post(`v1/apps/${wizardData.app.id}/switchboards/`, payload);
            
            if (res.data) {
                setStatus({ type: 'success', message: 'Switchboard criado com sucesso!' });
            
                console.log(`switchboard ${res.data.switchboardId} criado com sucesso!`);
            } else {
                setStatus({ type: 'error', message: 'Erro ao criar switchboard.' });
            }
        } catch (error) {
            console.error('Erro ao criar webhook', error.response?.data || error);
            setStatus({
                type: 'error',
                message: error.response?.data?.detail || 'Erro ao criar switchboard.'
            });
        }
    };

    //? --------------------------- MANIPULANDO FORMULÁRIO ---------------------------
    const handleChange = (e) => {
        const { name, value } = e.target;

        const newData = {
            ...wizardData,
            [name]: {
                ...wizardData[name],
                id: value
            }
        };

        if (name === 'app') {
            setAppFoiSelecionado(true);
        }

        setWizardData(newData);
    };

    const handlePediuCriarSw = () => {
        setPediuCriarSw(true);
    };

    return (
        <Card>
            <CardContent>
                {status.message && (
                    <Alert severity={status.type} sx={{ mb: 2 }}>
                        {status.message}
                    </Alert>
                )}

                <Typography variant="h2">Switchboards</Typography>

                {/* Select App */}
                <Grid item xs={12} sm={6} marginTop={3}>
                    <TextField
                        name="app"
                        select
                        label="Selecione o App"
                        required
                        fullWidth
                        value={wizardData.app.id || ''}
                        onChange={handleChange}
                    >
                        {listaApps.map((app) => (
                            <MenuItem key={app.id} value={app.id}>
                                {app.displayName}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>

                {switchboards.length > 0 && (
                    <CardContent>
                        <Box
                            sx={{
                                display: 'grid',
                                gridTemplateColumns: '200px 50px 50px 180px',
                                fontWeight: 'bold',
                                pb: 1,
                                borderBottom: '2px solid #eee'
                                // marginTop: 3
                            }}
                        >
                            <Typography>ID</Typography>
                            <Typography>Nome</Typography>
                            <Typography>Status</Typography>
                            <Typography>Resposta padrão</Typography>
                        </Box>

                        {/* Linhas da tabela */}
                        {switchboards.map((sw) => (
                            <Box
                                key={sw.id}
                                sx={{
                                    display: 'grid',
                                    gridTemplateColumns: '200px 50px 50px 180px',
                                    borderBottom: '1px solid #f0f0f0',
                                    py: 1,
                                    alignItems: 'center',
                                    cursor: 'pointer'
                                }}
                                onClick={(e) => {
                                    console.log('clicou no sw:', sw);
                                    // setOpenInfoApp(true);
                                    // setDetalhesApp(sw);
                                }}
                            >
                                {/* ID */}
                                <Typography>{sw.id}</Typography>

                                {/* Nome */}
                                <Typography>{sw.name}</Typography>

                                {/* Ativo */}
                                {sw.enabled === true && <Typography>Ativo</Typography>}
                                {sw.enabled === false && <Typography>Inativo</Typography>}
                                {/* <Typography>{sw.enabled}</Typography> */}

                                {/* Default SW integration */}
                                <Typography>{sw.defaultSwitchboardIntegrationId_id}</Typography>
                            </Box>
                        ))}
                    </CardContent>
                )}

                {appFoiSelecionado && (
                    <Button
                        variant="contained"
                        onClick={handlePediuCriarSw}
                        disabled={desabilitarPodeCriarSb}
                        sx={{ mr: 1, backgroundColor: '#32CD32', marginTop: 3 }}
                    >
                        Criar Switchboard
                    </Button>
                )}

                {pediuCriarSw && appFoiSelecionado && (
                    <>
                        <TextField
                            label="Nome do Switchboard"
                            fullWidth
                            margin="normal"
                            value={wizardData.switchboard.name}
                            onChange={(e) =>
                                setWizardData({
                                    ...wizardData,
                                    switchboard: { ...wizardData.switchboard, name: e.target.value }
                                })
                            }
                        />
                        <Button variant="contained" onClick={createSwitchboard} sx={{ mr: 1, backgroundColor: '#32CD32' }}>
                            Criar
                        </Button>
                        <Button variant="outlined" color="secondary" onClick={onClose}>
                            Voltar
                        </Button>
                    </>
                )}

                <Box sx={{ mt: 2 }}>
                    <Button variant="outlined" color="secondary" onClick={onClose}>
                        Voltar
                    </Button>
                </Box>
            </CardContent>
        </Card>
    );
};

export default SwitchboardNew;
